var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('v-tabs',{attrs:{"background-color":"white","color":"accent-4","left":""}},[_c('v-tab',[_vm._v("Kuponger")]),_c('v-tab',[_vm._v("Skapa ny")]),_c('v-tab-item',[_c('RedeemCodesTable',{ref:"redeemCodeTable"})],1),_c('v-tab-item',[_c('RedeemCodeEdit',{ref:"redeemCodeEdit"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }